// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-ycx","fullView":"styles_fullView__q6obk"};